<template>
<div class="wrpa">
    <div class="search_box flex_box">
        <div>
            <el-date-picker
                v-model="searchParams.times"
                type="daterange"
                format="yyyy年MM月dd日"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="活动开始日期"
                end-placeholder="活动结束日期">
            </el-date-picker>
        </div>
        <div style="width: 108px;">
            <el-select v-model="searchParams.assStatus" placeholder="助力状态">
                <el-option v-for="item in assStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
        </div>
        <div style="width: 220px;">
            <el-input v-model="searchParams.username" placeholder="请输入用户昵称"></el-input>
        </div>
        <div style="width: 220px;">
            <el-input v-model="searchParams.activityname" placeholder="请输入活动名称"></el-input>
        </div>
        <div>
            <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
        </div>
    </div>
    <div class="table_box">
        <el-table :data="orderListData" style="width: 100%">
            <el-table-column label="发起人" width="180">
                <template slot-scope="scope">
                    <div class="user_info_box flex_box">
                        <!-- <img :src="require('@/common/images/communityPurchases/logo.png')" alt=""> -->
                        <img :src="scope.row.customericonurl" alt="">
                        <span>{{scope.row.customername}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="活动名称" width="300" align='center'>
                <template slot-scope="scope">
                    <p class="activity_name_text">{{scope.row.eventname}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="factasscount" label="助力人数" align='center'></el-table-column>
            <el-table-column label="助力状态" align='center'>
                <template slot-scope="scope">
                    <p :class="assStatusClass(scope.row.assstatusname)">{{scope.row.assstatusname}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="ordertime" label="发起时间" width="160" align='center'></el-table-column>
            <el-table-column label="操作" align='right' width="150">
                <template slot-scope="scope">
                    <div class="handle_box flex_box">
                        <span @click="findHelpDetail(scope.row)">助力详情</span>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <page :total="total" ref="page" @getList="searchBtn"></page>
    </div>
    <div class="help_detail_pop_box">
        <!-- 助力详情弹窗 -->
        <HelpDetailPop :assDetailsInfo="assDetailsInfo" ref="helpDetails"></HelpDetailPop>
    </div>
</div>
</template>

<script>
import OrderDetailPop from 'views/taskTools/helpManagement/components/OrderDetailPop'
import HelpDetailPop from 'views/taskTools/helpManagement/components/HelpDetailPop'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {getAssOrderList, getAssOrderInfo, getAssAssistOrderList} from 'api/taskToolsApi2'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'OrderAdmin',
    data() {
        return {
            activeName: 'first',
            total: 0,
            searchParams: {
                username: '',
                activityname: '',
                assStatus: '',
                times: ''
            },
            assStatusOptions: [
                {
                    value: '0',
                    label: '全部状态'
                },
                {
                    value: '1',
                    label: '进行中'
                },
                {
                    value: '10',
                    label: '已完成'
                },
                {
                    value: '11',
                    label: '未完成'
                },
                {
                    value: '100',
                    label: '已取消'
                }
            ],
            orderListData: [],
            assDetailsInfo: {}
        }
    },
    mounted() {
        this.getAssOrderList()
    },
    methods: {
        // 助力订单列表
        getAssOrderList() {
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid
            }
            getAssAssistOrderList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.orderListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 助力详情（弹窗）
        findHelpDetail(val) {
            // this.setLoading(true)
            // console.log(val)
            var params = {
                orderno: val.assorderno
            }
            getAssOrderInfo({
                data: Object.assign({}, params),
                success: data => {
                    // this.setLoading(false)
                    this.assDetailsInfo = data.data
                    this.$refs.helpDetails.openDialog()
                },
                error: data => {
                    console.log('error：', data)
                    // this.setLoading(false)
                }
            })
        },
        // 分页及搜索
        handleQuery() {
            this.$refs.page.handleSizeChange(1)
        },
        // 搜索按钮
        searchBtn() {
            if (this.searchParams.times === null) {
                this.searchParams.times = ''
            }
            this.setLoading(true)
            var params = {
                eventinnerid: this.$route.query.eventinnerid,
                begintime: this.searchParams.times[0],
                endtime: this.searchParams.times[1],
                assstatus: this.searchParams.assStatus === '0' ? '' : this.searchParams.assStatus,
                customername: this.searchParams.username,
                eventname: this.searchParams.activityname
            }
            // console.log(params)
            getAssAssistOrderList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    this.orderListData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        assStatusClass(val) {
            if (val === '已取消' || val === '未完成') {
                return 'gray_text'
            } else if (val === '已完成') {
                return 'green_text'
            } else if (val === '进行中') {
                return 'yellow_text'
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    filters: {},
    watch: {},
    computed: {
        ...mapGetters([
            'page'
        ])
    },
    components: {
        Page,
        HelpDetailPop
    }
}
</script>

<style lang="scss" type="text/scss"></style>